import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  header: {
    padding: '18px 32px',
    boxShadow: palette.shadows.light,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    '& + &': {
      marginTop: '10px'
    }
  },
  infoTitle: {
    width: '240px',
    flexShrink: '0',
    marginRight: '10px'
  },
  pod: {
    paddingTop: '20px',
    marginTop: '20px',
    borderTop: "1px solid ".concat(palette.shades[400])
  },
  content: {
    padding: '32px 40px'
  }
});
export default useStyles;